import gql from 'graphql-tag';

export const FrequentSearchListQuery = gql`
	query FrequentSearchListQuery(
		$first: Int
		$cursor: String
		$filter: FrequentSearchFilterInput
	) {
		entities: frequentSearchs(
			first: $first
			after: $cursor
			filter: $filter
		) {
			edges {
				node {
					id
					localId
					name
					collection
					isDynamic
					User {
						id
						name
					}
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;


